import React from 'react';
import classnames from 'classnames';
import Carousel, { CarouselArrow } from '../Carousel';
import { useResponsiveCarousel } from '../../hooks/useResponsiveCarousel';

interface ResponsiveCarouselProps {
  children: React.ReactNode;
  className?: string;
  arrowHeight?: {
    mobile?: string;
    sm?: string;
    tablet?: string;
    desktop?: string;
    xl?: string;
  };
  containerClassName?: string;
}

const ResponsiveCarousel: React.FC<ResponsiveCarouselProps> = ({
  children,
  className,
  arrowHeight = {
    mobile: 'h-[235px]',
    sm: 'sm:h-[223px]',
    tablet: 'md:h-[199px]',
    desktop: 'lg:h-[271px]',
    xl: 'xl:h-[271px]',
  },
  containerClassName = 'relative mb-2 md:mb-4 lg:mb-14',
}) => {
  const { slidesPerView, gap } = useResponsiveCarousel();

  const baseArrowClassName = classnames(
    'absolute h-[235px]',
    'sm:h-[420px]',
    'md:h-[223px]',
    'lg:h-[199px]',
    'lgx:h-[229px]',
    'xl:h-[257px]',
    'xxl:h-[271px]',
    'top-0 h-auto flex items-center px-3 md:px-3.5 xl:px-4 transition-colors'
  );

  const prevArrowClassName = classnames(
    baseArrowClassName,
    'z-10',
    // Mobile positioning: 30px outside on left side - using !important to override default
    'md:!left-0'
  );

  const nextArrowClassName = classnames(
    baseArrowClassName,
    // Mobile positioning: 30px outside on right side - using !important to override default
    'md:!right-0'
  );

  return (
    <div className={containerClassName}>
      <Carousel
        className={className}
        emblaOptions={{
          startIndex: 0,
          containScroll: 'trimSnaps',
          duration: 20,
          align: 'start',
          loop: true,
        }}
        slidesPerView={slidesPerView as 1 | 2 | 3 | 4}
        gap={gap}
        customPrevArrow={
          <CarouselArrow
            onClick={() => {}}
            isVisible={true}
            direction="prev"
            className={prevArrowClassName}
          />
        }
        customNextArrow={
          <CarouselArrow
            onClick={() => {}}
            isVisible={true}
            direction="next"
            className={nextArrowClassName}
          />
        }
      >
        {children}
      </Carousel>
    </div>
  );
};

export default ResponsiveCarousel;
